import Phaser from 'phaser';
import { getDistance, pointAlongLine, angleBetweenPoints } from './helpers';
import { DiceObject } from './DiceObject';
import { store } from '../stores/mainStore';
import { integration } from '../integration';

var m;
export class DiceHand {
	constructor(mgr) {
		m = mgr;
	}

	dice = [];
	diceLaunched = 0;
	collisionMask = 0;
	group;

	create = () => {
		for (let i = 0; i < 9; i++) {
			var d = new DiceObject(i, m);
			d.diceNum = i;
			var pos = this.getDiceHomePosition(i);
			this.reCreateDice(d, pos, i);
			this.dice.push(d);
		}
	};
	reCreate = () => {
		for (let i = 0; i < 9; i++) {
			var d = this.dice[i];
			var pos = this.getDiceHomePosition(i);
			this.reCreateDice(d, pos, i);
		}
	};
	reCreateDice = (d, pos, ind) => {
		var rest = 0.8;
		var i = d.diceNum;
		//d.diceImage = m.scene.add.sprite(0, 0, store.custom.dice + '_dice2D_sheet').setFrame(i * 6);
		d.diceImage = m.scene.add.sprite(0, 0, 'dice2D_sheet').setFrame(i * 6);
		m.diceInstances.add(d.diceImage)
		d.diceContainer = m.scene.add.container(pos.x, pos.y, [d.diceImage]);
		//  A Container has a default size of 0x0, so we need to give it a size before enabling a physics body
		d.diceContainer.setSize(d.diceImage.width, d.diceImage.height);
		d.diceSprite = m.scene.matter.add.gameObject(d.diceContainer);
		d.diceSprite.setFriction(0.35);
		d.diceSprite.setBounce(rest);
		d.diceSprite.setScale(m.diceBigScale);

		d.diceSprite.setInteractive();

		d.frameNum = 0;
		d.currentFace = 0;
		d.locked = false;
		d.homePosition = { x: pos.x, y: pos.y };
		d.defaultHomePosition = { x: pos.x, y: pos.y };
		d.lastPosition = { x: 0, y: 0 };

		d.diceSprite.body.moves = false;

		d.diceSprite.setRectangle(128, 128);

		d.diceSprite.body.collisionFilter.group = -1;
		this.collisionMask = d.diceSprite.body.collisionFilter.mask;
		d.diceSprite.body.collisionFilter.mask = 0;
		d.diceSprite.body.inertia = Infinity;

		d.diceSprite.diceNum = i;
		d.diceSprite.on('pointerup', this.onPointerUp);
		d.diceSprite.on('pointerdown', this.onPointerDown);
		
	};

	getDiceHomePosition = (diceNum) => {
		var gridX = diceNum % 3;
		var gridY = Math.trunc(diceNum / 3);
		var posX = m.diceLeft + gridX * (m.diceActualWidth + m.diceGridPad);
		var posY = m.diceTop + gridY * (m.diceActualWidth + m.diceGridPad);
		return { x: posX, y: posY };
	};

	onPointerUp(pointer) {
		var j = this.diceNum;
		if (m.diceStatus !== 'resolved' ||
			store.activeMatch.currentHand.rollsRemaining === 0 ||
			store.activeMatch.currentHand.rollsRemaining === 3 ||
			store.activeMatch.currentHand.best
		)
			return;

		if (store.activeMatch.currentHand.rollsRemaining < 1) {
			const pulseComplete = () => {
				m.ui.button2.setScale(m.ui.button2.normalScale);
			}
			if(m.ui.button2.scaleX === m.ui.button2.normalScale) {
				m.ui.button2.setScale(m.ui.button2.normalScale * 1.001);
				m.ui.makePulsate(m.ui.button2, 350, 1.2, false, pulseComplete);
			}
			return;
		}

		if (m.zoomerContainer != null) {
			var diceObjects = m.diceHand.dice;
			m.ui.unZoomZoomer(diceObjects[j].homePosition.y);
			m.playAudio('pop');
			return;
		}

		if (store.tutorialMode && store.tutorialState === 'handInfo') store.tutorialState = '';

		m.diceHand.toggleHold(j);
	}
	toggleHold(j) {
		var dieResult = store.activeMatch.currentHand.hold(j);
		if (dieResult) {
			if (dieResult.held) {
				m.diceHand.dice[j].addFlair('selected', store.settings.theme);
				m.playAudio('diceSelect');
				integration.postEvent(`dice_hold`, 'gameplay');
			} else {
				m.diceHand.dice[j].removeFlair();
				m.playAudio('diceDeselect');
				integration.postEvent(`dice_release`, 'gameplay');
			}
			m.diceHand.dice[j].locked = dieResult.held;
		}
	}
	unHoldAllDice() {
		m.diceHand.dice.forEach(element => {
			this.unHold(element.diceNum);
		});
	}
	unHold(j) {
		var dieResult = store.activeMatch.currentHand.hold(j);
		if (dieResult) {
			if (dieResult.held) 
				dieResult = store.activeMatch.currentHand.hold(j);
			m.diceHand.dice[j].locked = dieResult.held;
		}
	}
	onPointerDown(pointer) {
		if (
			m.diceStatus !== 'resolved' ||
			store.activeMatch.currentHand.rollsRemaining === 0 ||
			store.activeMatch.currentHand.rollsRemaining === 3 ||
			store.activeMatch.currentHand.best
		)
			return;
		var j = this.diceNum;
		var diceObjects = m.diceHand.dice;

		if (m.zoomerContainer != null) {
			if (j === m.lastZoomedDice) m.ui.zoomZoomer(diceObjects[j].homePosition.y - 44);
			else {
				m.ui.showZoomer(j);
				m.ui.zoomZoomer(diceObjects[j].homePosition.y - 44);
			}
			m.playAudio('poop');
			integration.postEvent('dice_reveal', 'gameplay');
		}
	}
	launchDice = () => {
		m.diceStatus = 'launching';
		m.cup.diceLaunchPosition = { x: m.cup.cupSprite.x, y: m.cup.cupSprite.y };
		m.ui.bumperDelay = 200;
		m.ui.startBumperDelay();
		m.diceHand.clearDiceSounds();
		var distance = getDistance(m.cup.cupSprite.x, m.cup.cupSprite.y, m.aimPoint.x, m.aimPoint.y);
		var maxDistance = getDistance(0, m.config.height + m.cup.cupSprite.height * 1.5, m.aimPoint.x, m.aimPoint.y);
		var targetPoint = pointAlongLine(
			maxDistance / distance,
			m.aimPoint.x,
			m.aimPoint.y,
			m.cup.cupSprite.x,
			m.cup.cupSprite.y
		);
		m.scene.tweens.add({
			targets: [m.cup.cupSprite],
			x: targetPoint.x,
			y: targetPoint.y,
			ease: 'Linear',
			duration: 900,
			repeat: 0,
			completeDelay: 0,
			onComplete: function (tween, target) {
				m.cup.hideCup();
			}
		});
	};

	clearDiceOffScreen = () => {
		this.dice.forEach((d) => {
			d.diceSprite.x = d.homePosition.x;
			d.diceSprite.y = d.homePosition.y;
			d.diceSprite.y -= m.config.height * 0.75;
		});
	};
	areDiceOffScreen = () => {
		var numOnScreen = 0;
		this.dice.forEach((d) => {
			if (d.diceSprite.y > 0) numOnScreen++;
		});
		return numOnScreen === 0;
	};
	darkenUnlockedDice = () => {
		this.dice.forEach((d) => {
			if (!d.locked) {
				d.removeFlair();
				d.highlight = m.scene.add.sprite(d.diceSprite.x-1, d.diceSprite.y-1, 'flair');
				d.highlight.setScale(m.highlightScale*1.01);
				d.highlight.setAlpha(0.4);
				// d.highlight.setFrame(1);
			}
		});
	};
	clearDarkenedUnlockedDice = () => {
		this.dice.forEach((d) => {
			if (d.highlight && d.highlight.alpha === 0.4) {
				d.removeFlair();
			}
		});
	};

	unlockAllDice = () => {
		this.dice.forEach((d, i) => {
			d.locked = false;
			d.removeFlair();
		});
	};
	clearDiceSounds = () => {
		this.dice.forEach((d, i) => {
			d.soundsPlayed = 0;
		});
	};

	launchNextDice = () => {
		if (this.diceLaunched >= 9) return;

		var i = this.diceLaunched;
		let d = this.dice[i];
		if (d.locked) {
			d.frameNum = -1;
			return;
		}
		d.frameNum = 0;
		if(!store.pokerRush)
			d.currentFace = store.activeMatch.currentHand.dice[i].showing;

		d.diceSprite.x = m.cup.diceLaunchPosition.x + d.tinyDeltaX;
		d.diceSprite.y = m.cup.diceLaunchPosition.y + d.tinyDeltaY;

		d.diceSprite.setScale(m.diceTinyScale*2);
		d.diceSprite.setAlpha(1.0);
		m.scene.tweens.add({
			targets: [d.diceSprite],
			scaleX: m.diceEndScale * 2,
			scaleY: m.diceEndScale * 2,
			ease: 'Linear',
			duration: 150,
		});

		var diceVelocity = new Phaser.Math.Vector2();
		var distance = getDistance(m.cup.cupReleasePosition.x, m.cup.cupReleasePosition.y, m.aimPoint.x, m.aimPoint.y);
		var maxDistance = getDistance(m.farthestLaunchPoint.x, m.farthestLaunchPoint.y, m.aimPoint.x, m.aimPoint.y);
		var cupPower = distance / maxDistance;
		if (cupPower < 0.3)			cupPower = 0.3;
		if (cupPower > 0.9)			cupPower = 0.9;
		var vel = Phaser.Math.Between(1200, 1600);
		vel = 170; //100;
		vel *= cupPower;
		var rnd = Math.random() * 0.25;
		rnd *= vel;
		vel += rnd;

		var angle = angleBetweenPoints({ x: m.cup.cupReleasePosition.x, y: m.cup.cupReleasePosition.y }, m.aimPoint);
		rnd = Math.random() * (angle > 80 && angle < 100 ? 25 : 23.0);
		if (Math.random() < 0.5) rnd = -rnd;
		angle += rnd;

		rnd = Math.random() * 60;
		if (Math.random() < 0.5) rnd = -rnd;

		var dX = m.cup.cupReleasePosition.x - (m.aimPoint.x + rnd);
		var dY = m.cup.cupReleasePosition.y - m.aimPoint.y;
		dX = dX / dY; // ((Math.abs(dX) / Math.abs(dY)));
		dY /= Math.abs(dY);

		diceVelocity = { x: -dX * vel, y: -dY * vel };
		d.diceSprite.body.moves = true;
		d.diceSprite.body.collisionFilter.group = 0;
		d.diceSprite.body.collisionFilter.mask = m.diceHand.collisionMask;
		d.diceSprite.setStatic(false);

		d.diceSprite.setBounce(0.6);
		d.diceSprite.setFrictionAir(0.06);	//0.06
		d.diceSprite.setVelocity(diceVelocity.x, diceVelocity.y);
		d.diceSprite.body.angularVelocity = 0; // vel;
	};
	DegToRad = (degrees) => {
		var pi = Math.PI;
		return degrees * (pi / 180);
	};
	velocityFromAngle = (angle, speed, vec2) => {
		if (speed === undefined) {
			speed = 60;
		}
		if (vec2 === undefined) {
			vec2 = new Phaser.Math.Vector2();
		}
		return vec2.setToPolar(this.DegToRad(angle), speed);
	};

	resetDicePriority = () => {
		this.dice.forEach((d) => {
			d.diceSprite.setDepth(0);
		});
	};

	sortLockedDice = () => {
		var val;
		this.dice.forEach((d) => {
			d.lockedSortOrder = -1;
		});
		var index = 0;
		var sorter = (d) => {
			if (d.locked && this.getFaceValue(d) === val && d.lockedSortOrder < 0) {
				d.lockedSortOrder = index++;
			}
		};
		for (val = 15; val >= 0; val--) {
			this.dice.forEach(sorter);
		}
	};

	getFaceValue = (d) => {
		var diceValues = [
			[7, 3, 11, 5, 14, 9],
			[14, 4, 8, 15, 6, 7],
			[5, 12, 10, 2, 8, 13],
			[12, 10, 13, 4, 9, 2],
			[14, 3, 9, 6, 4, 11],
			[2, 3, 8, 6, 15, 12],
			[12, 7, 9, 13, 10, 5],
			[11, 6, 5, 14, 3, 4],
			[13, 11, 8, 10, 7, 2],
		];
		return diceValues[d.diceNum][d.currentFace];
	};

	diceInCupHaptic = () => {
		m.diceHand.hapticMsg =
			m.diceHand.diceUnlocked < 4
				? 'haptic_lightImpact'
				: m.diceHand.diceUnlocked < 7
				? 'haptic_mediumImpact'
				: 'haptic_mediumImpact';
		console.log('sending diceInCupHaptic msg ' + m.diceHand.hapticMsg);
		let delay = 70;
		let num = Math.floor(m.diceHand.diceUnlocked / 3);
		let sfxName = m.diceHand.diceUnlocked < 2 ? 'die1' : m.diceHand.diceUnlocked < 7 ? 'die4' : 'die9';
		m.playHaptic(m.diceHand.hapticMsg, sfxName);
		for (var i = 0; i < num - 1; i++, delay += 70) setTimeout(m.diceHand.cupHaptic, delay);
	};
	cupHaptic = () => {
		m.playHaptic(m.diceHand.hapticMsg);
	};
	hapticMsg;
	lilScale;
	diceUnlocked;

	sendDiceToCup = (animate) => {
		if (m.dailyBonusSkipButton){
				m.dailyBonusSkipButton.destroy(true);
		}
		//send dice to cup
		this.diceUnlocked = 0;
		m.diceStatus = 'sendToCup';
		m.ui.fadeGoalBanner(false)

		var lastDiceSentToCup;
		var boardCenter = this.dice[5].defaultHomePosition;
		this.sortLockedDice(); //only for order displayed for tiny dice at top of screen
		var onAnimationComplete = (tween, target, num) => {
			if (num === lastDiceSentToCup) {
				m.cup.showDiceInCup();
				this.diceLaunched = 0;
				if (m.readyToLaunch) {
					m.readyToLaunch = false;
					m.diceStatus = 'launch';
					m.cup.launchCup();
				} else m.diceStatus = 'arrivedInCup';
			}
		};

		for (let i = 0; i < 9; i++) {
			let d = this.dice[i];
			d.diceSprite.body.moves = false;
			d.diceSprite.body.collisionFilter.group = -1;
			d.diceSprite.body.collisionFilter.mask = 0;
			if (d.locked) {
				let x = 0;
				let y = 0;
				let grid = false;
				let lilSize = 35 * m.scaleFactor;
				if (!grid) {
					// straight line at top:
					lilSize = 51 * m.scaleFactor;
					let lilLeftEdge = m.config.width / 2 - (store.activeMatch.currentHand.heldDiceCount * lilSize) / 2;
					x = lilLeftEdge + d.lockedSortOrder * lilSize;
					x += lilSize / 2;
					y = m.handBannerPosition + 6 * m.scaleFactor; //+67;
				} else {
					// grid at top right:
					let lilLeft = m.config.width - lilSize * 2.625;
					let lilTop = lilSize * 0.625;
					lilTop += m.gameHud.hudBackHeight;
					let leftEdge = this.dice[0].defaultHomePosition.x;
					let topEdge = this.dice[0].defaultHomePosition.y;
					let lilDistFromLeft = (d.homePosition.x - leftEdge) * this.lilScale * 2;
					let lilDistFromTop = (d.homePosition.y - topEdge) * this.lilScale * 2;

					x = lilLeft + lilDistFromLeft;
					y = lilTop + lilDistFromTop;
				}
				this.lilScale = lilSize / m.diceFullRes;

				d.diceSprite.setDepth(4);

				if (animate) {
					m.scene.tweens.add({
						targets: [d.diceSprite],
						x: x,
						y: y,
						scaleX: this.lilScale,
						scaleY: this.lilScale,
						ease: 'Linear',
						duration: 100,
					});
				} else {
					d.diceSprite.x = x;
					d.diceSprite.y = y;
					d.diceSprite.setScale(this.lilScale);
				}
			} else {
				const lilAlpha = 0;
				this.diceUnlocked++;
				lastDiceSentToCup = d.diceNum;
				var scale = m.diceTinyScale * 1.4;
				d.tinyDeltaX = (d.defaultHomePosition.x - boardCenter.x) * scale;
				d.tinyDeltaX += 50;
				d.tinyDeltaY = (d.defaultHomePosition.y - boardCenter.y) * (scale * 0.4);
				d.tinyDeltaY += (i % 3) * 7.5;
				d.diceSprite.body.moves = false;
				d.diceSprite.body.collisionFilter.group = -1;
				d.diceSprite.body.collisionFilter.mask = 0;

				if (animate) {
					var onScreen = d.diceSprite.y >= 0;
					if (!onScreen) d.diceSprite.setAlpha(lilAlpha);
					m.scene.tweens.add({
						targets: [d.diceSprite],
						x: m.cup.cupSprite.x + d.tinyDeltaX,
						y: m.cup.cupSprite.y + d.tinyDeltaY,
						scaleX: 0.01,
						scaleY: 0.01,
						alpha: lilAlpha,
						angle: Math.random() * 359,
						ease: 'Linear',
						duration: onScreen ? 100 : 20,
						repeat: 0,
						completeDelay: 0,
						onComplete: onAnimationComplete,
						onCompleteParams: [d.diceNum],
						onCompleteScope: this,
					});
				} else {
					d.diceSprite.x = m.cup.cupSprite.x + d.tinyDeltaX;
					d.diceSprite.y = m.cup.cupSprite.y + d.tinyDeltaY;
					d.diceSprite.setScale(0.01);
					d.diceSprite.setAlpha(lilAlpha);
					d.diceSprite.angle = Math.random() * 359;
				}
			}
		}
		if (!animate) {
			m.cup.showDiceInCup();
			this.diceLaunched = 0;
			if (m.readyToLaunch) {
				m.readyToLaunch = false;
				m.diceStatus = 'launch';
				m.cup.launchCup();
			} else m.diceStatus = 'arrivedInCup';
		}
		gameSetTimeout(m.diceHand.diceInCupHaptic, 50);
	};

	endIntroDiceIntoCup() {
		m.diceHand.resetDicePriority();

		if (!(store.tutorialMode && store.activeMatch.matchId === 'intro')) 
			m.cup.hideCup();
		else if(store.activeMatch.matchId === 'intro2')
			m.cup.waitForHandPointer = true;

		m.diceStatus = 'resolved';
		m.ui.prepareTable();
		integration.postEvent('ftue_ready', 'ftue');
	}
	introDiceIntoCup = () => {
		//m.setSafeAreaBanners('blue', 'blue');
		integration.postEvent('ftue_dice_fall', 'ftue');

		//send dice to cup
		m.clearMessages();
		m.diceStatus = 'introToCup';
		var lastDiceSentToCup;
		for (let i = 0; i < 9; i++) {
			let d = this.dice[i];
			d.diceSprite.x = m.config.width;
			d.diceSprite.y = -120 * m.scaleFactor;
			d.diceSprite.setScale(0.8 * m.scaleFactor * 2);
			d.diceSprite.setAlpha(1.0);
			d.diceSprite.setDepth(4);
		}

		m.cup.waitForHandPointer = true;

		m.cup.reallyFakeReturnCup(false);
		//var cupOverlay = m.scene.add.sprite(m.cup.cupHomeposition.x - 1, m.cup.cupHomeposition.y, store.custom.cup + '_cup_sheet');
		var cupOverlay = m.scene.add.sprite(m.cup.cupHomeposition.x - 1, m.cup.cupHomeposition.y, 'cup_sheet');
		cupOverlay.setFrame(5);
		cupOverlay.setScale(m.cup.cupSprite.scale);
		cupOverlay.angle = m.cup.cupSprite.angle;
		cupOverlay.setOrigin(0.5, 0.05);
		cupOverlay.setDepth(5);
		m.scoreCardElements.push(cupOverlay);

		var onAnimationComplete = (tween, target, num) => {
			m.playAudio('die' + (num + 1));
			m.diceHand.dice[num].diceSprite.setAlpha(0);
			if (num === lastDiceSentToCup) {
				m.cup.showDiceInCup();
				gameSetTimeout(m.diceHand.endIntroDiceIntoCup, 750);
			}
		};
		for (let i = 0; i < 9; i++) {
			let d = this.dice[i];
			d.diceSprite.body.moves = false;
			d.diceSprite.body.collisionFilter.group = -1;
			d.diceSprite.body.collisionFilter.mask = 0;

			lastDiceSentToCup = d.diceNum;
			d.tinyDeltaX = -5 * m.scaleFactor;
			d.tinyDeltaY = 28 * m.scaleFactor; 
			d.diceSprite.body.moves = false;
			d.diceSprite.body.collisionFilter.group = -1;
			d.diceSprite.body.collisionFilter.mask = 0;
			m.scene.tweens.add({
				targets: [d.diceSprite],
				x: m.cup.cupHomeposition.x + d.tinyDeltaX,
				y: m.cup.cupHomeposition.y + d.tinyDeltaY,
				scaleX: 0.2 * m.scaleFactor * 2,
				scaleY: 0.2 * m.scaleFactor * 2,
				ease: 'Linear',
				delay: (840 / 3) * i,
				duration: 840,
				repeat: 0,
				completeDelay: 0,
				onComplete: onAnimationComplete,
				onCompleteParams: [d.diceNum],
				onCompleteScope: this,
			});
		}
	};

	resumeFromHeart = () => {
		store.activeMatch.currentHand.ensureBestHandIsHeld();
		this.resetDicePriority();
		this.dice.forEach((d) => {
			d.removeFlair();
			if (d.locked) {
				m.scene.tweens.add({
					targets: [d.diceSprite],
					x: d.homePosition.x,
					y: d.homePosition.y,
					scaleX: m.diceBigScale,
					scaleY: m.diceBigScale,
					ease: 'Linear',
					duration: 420,
					repeat: 0,
					completeDelay: 0,
					onComplete: function (tween, target, num) {
						if (this.dice[num].locked) {
							this.dice[num].addFlair('selected', store.settings.theme);
						}
					},
					onCompleteParams: [d.diceNum],
					onCompleteScope: this,
				});
			}
		});
	};
	restoreDiceFromResume = () => {
		this.unlockAllDice();
		var heldList = store.activeMatch.currentHand.heldIndexes;
		var diceObjects = m.diceHand.dice;
		diceObjects.forEach((d) => {
			d.diceSprite.x = d.defaultHomePosition.x;
			d.diceSprite.y = d.defaultHomePosition.y;
			var i = d.diceNum;
			d.currentFace = store.activeMatch.currentHand.dice[i].showing;
			if (d.currentFace === null) {
				console.warn('d.currentFace was null', d);
				d.currentFace = 0;
			}
			var num = i * 6 + d.currentFace;
			//d.diceImage.setTexture(store.custom.dice + '_dice2D_sheet');
			d.diceImage.setTexture('dice2D_sheet');
			d.diceImage.setFrame(num);
		});
		heldList.forEach((d) => {
			diceObjects[d].addFlair('selected', store.settings.theme);
			diceObjects[d].locked = true;
			diceObjects[d].frameNum = -1;
		});
	};
	resolveGridToHorizontal = () => {
		var count = store.activeMatch.currentHand.match.length;
		var stageWidth = m.diceActualWidth * 4; // m.config.width * 0.9;
		var diceWidth = stageWidth / count;
		var minWidth = stageWidth / 5;
		var adjust = diceWidth / m.diceActualWidth;
		var scaleToUse = m.diceBigScale * adjust;
		var totalWidth = count * diceWidth;
		var diceY = this.dice[5].defaultHomePosition.y + m.diceActualWidth * (minWidth / diceWidth);
		var leftPosition = m.config.width / 2 - totalWidth / 2;
		leftPosition += diceWidth / 2;

		this.resetDicePriority();

		store.activeMatch.currentHand.match.forEach((dieIndex, i) => {
			var d = this.dice[dieIndex];
			var x = leftPosition + i * diceWidth;
			d.diceSprite.setDepth(1);
			m.scene.tweens.add({
				targets: [d.diceSprite],
				x: x,
				y: diceY,
				scaleX: scaleToUse,
				scaleY: scaleToUse,
				ease: 'Linear',
				duration: 420
			});
		});
	};
}
